import { render } from "./FAQManagement.vue?vue&type=template&id=211a7e79&scoped=true"
import script from "./FAQManagement.vue?vue&type=script&lang=js"
export * from "./FAQManagement.vue?vue&type=script&lang=js"

import "./FAQManagement.vue?vue&type=style&index=0&id=211a7e79&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-211a7e79"],['__file',"src/views/FAQManagement/FAQManagement.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "211a7e79"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('211a7e79', __exports__)) {
    api.reload('211a7e79', __exports__)
  }
  
  module.hot.accept("./FAQManagement.vue?vue&type=template&id=211a7e79&scoped=true", () => {
    api.rerender('211a7e79', render)
  })

}


export default __exports__